import { render } from "./systemCenter.vue?vue&type=template&id=ea83b364&scoped=true"
import script from "./systemCenter.vue?vue&type=script&lang=js"
export * from "./systemCenter.vue?vue&type=script&lang=js"

import "./systemCenter.vue?vue&type=style&index=0&id=ea83b364&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea83b364"]])

export default __exports__